import { distinctUntilChanged } from 'rxjs';

export const distinctUntilChangedJSONCheck = distinctUntilChanged(
  <T>(previous: T, current: T) => JSON.stringify(previous) === JSON.stringify(current)
);
